// draftStorage.ts — the editor's crash mat. The template lives in React state, so a refresh used to throw
// away everything authored since the last Save. Every edit writes a draft here; the editor offers it back
// on load instead of restoring silently, because the author may have opened a different level meanwhile.
import { CURRENT_SCHEMA_VERSION } from "../Models/Editor/EditorLevel";
const KEY = "conveyor.levelEditor.draft";
// Reads the stored draft, or null when there isn't one, it can't be parsed, or it was written by an older
// schema. Storage can throw outright (private mode, disabled cookies) — a missing draft is never worth an
// exception in render.
export function readDraft() {
    try {
        const raw = window.localStorage.getItem(KEY);
        if (!raw) {
            return null;
        }
        const parsed = JSON.parse(raw);
        const t = parsed.template;
        // Enough of a shape check that Restore cannot hand the editor something render() will throw on.
        // The draft is written by this app, so the only way a malformed one gets here is a malformed Drive
        // file that was opened and then edited — and there is no error boundary to catch the result.
        if (!t ||
            typeof t !== "object" ||
            t.schemaVersion !== CURRENT_SCHEMA_VERSION ||
            !t.generation ||
            !t.cells ||
            !Array.isArray(t.cells.items) ||
            !Array.isArray(t.cells.modifiers)) {
            return null;
        }
        return { savedAt: typeof parsed.savedAt === "number" ? parsed.savedAt : 0, template: t };
    }
    catch {
        return null;
    }
}
export function writeDraft(template) {
    try {
        window.localStorage.setItem(KEY, JSON.stringify({ savedAt: Date.now(), template }));
    }
    catch {
        // Out of quota or storage disabled — losing the crash mat must never break authoring.
    }
}
export function clearDraft() {
    try {
        window.localStorage.removeItem(KEY);
    }
    catch {
        // see writeDraft
    }
}
